import PropTypes from 'prop-types';
import { useContext, useEffect, useRef } from 'react';

import ModalContext from './ModalContext';

const ModalContent = ({ children, className }) => {
  const { setIsScrollableHeight } = useContext(ModalContext);
  const modalContentRef = useRef();

  useEffect(() => {
    const modalContentElement = modalContentRef.current;

    if (
      modalContentElement &&
      modalContentElement.offsetHeight < modalContentElement.scrollHeight
    ) {
      setIsScrollableHeight(true);
    }
    return () => {
      setIsScrollableHeight(false);
    };
  }, [setIsScrollableHeight]);
  return (
    <div
      className={`h-full py-4 px-6 ${className || ''}`}
      ref={modalContentRef}
    >
      {children}
    </div>
  );
};

ModalContent.defaultProps = {
  className: '',
};

ModalContent.propTypes = {
  children: PropTypes.node.isRequired,
  /**
   * Additional CSS classes to add to the content container
   */
  className: PropTypes.string,
};

export default ModalContent;
